/* Publish by EComposer at 2026-10-23 02:59:30*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-o6mord50gyk"]=  window.__ectimmers["ecom-o6mord50gyk"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-o6mord50gyk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o6mord50gyk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1zo7fsgcoot').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1zo7fsgcoot', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1xh8sukzrif').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1xh8sukzrif', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m8flj29ws1c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m8flj29ws1c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4rptmhl4fz3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4rptmhl4fz3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gpicw5g21ub').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gpicw5g21ub', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8jg9vtrd95t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8jg9vtrd95t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7ejzhfn0hl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7ejzhfn0hl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l8x14h9pfp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l8x14h9pfp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2aaodf1ye7d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2aaodf1ye7d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-df1tamld1j9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-df1tamld1j9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-he3ib8395wk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-he3ib8395wk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i8qx6673vz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i8qx6673vz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xmq6kd0mh7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xmq6kd0mh7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v1zb2qbovph').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v1zb2qbovph', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oyodfo5s8q8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oyodfo5s8q8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-11hc83edk37i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-11hc83edk37i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8q0xdyut949').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8q0xdyut949', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e8ez9yayb6a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e8ez9yayb6a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3k13ifzscp6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3k13ifzscp6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t1oyg735ya').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t1oyg735ya', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1l94aidm8vbi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1l94aidm8vbi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g948a1acggj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g948a1acggj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cmdljwbez1n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cmdljwbez1n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4taaozldhj5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4taaozldhj5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hse5xivtakd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hse5xivtakd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n7udjdn2os9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n7udjdn2os9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-am2qk93j78').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-am2qk93j78', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rez9di9mr4i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rez9di9mr4i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h9wf9w2bcr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h9wf9w2bcr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u7xjrhrcz2a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u7xjrhrcz2a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6wv1nqxnqsv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6wv1nqxnqsv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-57l4mx265w8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-57l4mx265w8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ra4hhhcwtbg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ra4hhhcwtbg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ofpnpvjyrvn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ofpnpvjyrvn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zicmygomcr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zicmygomcr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6dusfdnyqrr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6dusfdnyqrr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-264845xp55i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-264845xp55i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-skws76qzzgi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-skws76qzzgi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m9dhn99e19').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m9dhn99e19', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kz05x3cgdyi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kz05x3cgdyi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a1mhcs4xb3e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a1mhcs4xb3e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vrv86f7ir8a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vrv86f7ir8a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fookzlebgjb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fookzlebgjb', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-j4xpi4tceoj"]=  window.__ectimmers["ecom-j4xpi4tceoj"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-j4xpi4tceoj"]["tx7dgj8s3"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-j4xpi4tceoj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j4xpi4tceoj', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-rqhnal5njah"]=  window.__ectimmers["ecom-rqhnal5njah"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-rqhnal5njah"]["ajbq6sryb"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-rqhnal5njah').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rqhnal5njah', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gg13sjie1eh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gg13sjie1eh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lzsu6nkeeoq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lzsu6nkeeoq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k7idrojwka').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k7idrojwka', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jl0wy6h69er').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jl0wy6h69er', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ykrellcxvse').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ykrellcxvse', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mgitbxx7pal').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mgitbxx7pal', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pzb93dscp1s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pzb93dscp1s', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k8oe9wuv6d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k8oe9wuv6d', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dmezt9b9rg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dmezt9b9rg', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hgy5kxonhz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hgy5kxonhz', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gewumxqtm8j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gewumxqtm8j', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s5w9uz4kaij').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s5w9uz4kaij', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4p7e5vvkjhp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4p7e5vvkjhp', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7lljt5j4txs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7lljt5j4txs', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pi9bnot1xef').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pi9bnot1xef', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a0z914rzu9m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a0z914rzu9m', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-grxzh5kaqcj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-grxzh5kaqcj', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8bpbn107xhn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8bpbn107xhn', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}